import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import R from 'ramda';
import classNames from 'classnames';

import styles from './vertical-container.css';

const { div } = hh(h);

const VerticalContainer = (props) => {
    const sizeClass = R.prop(props.size, styles);

    return div({className: classNames(styles.container, sizeClass)}, props.children);
};

export default VerticalContainer;



/** WEBPACK FOOTER **
 ** ./src/VerticalContainer/index.js
 **/